@file:OptIn(InternalResourceApi::class)

package rainbowclubs.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/rainbowclubs.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_560_708_349)
internal val Res.string.event_time_placeholder: StringResource by lazy {
      StringResource("string:event_time_placeholder", "event_time_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4504, 38),
      ))
    }

@delegate:ResourceContentHash(1_969_956_027)
internal val Res.string.event_title_icon_cd: StringResource by lazy {
      StringResource("string:event_title_icon_cd", "event_title_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1020, 51),
      ))
    }

@delegate:ResourceContentHash(1_285_353_122)
internal val Res.string.event_title_label: StringResource by lazy {
      StringResource("string:event_title_label", "event_title_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4543, 33),
      ))
    }

@delegate:ResourceContentHash(-619_813_886)
internal val Res.string.event_title_placeholder: StringResource by lazy {
      StringResource("string:event_title_placeholder", "event_title_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4577, 55),
      ))
    }

@delegate:ResourceContentHash(-1_195_890_409)
internal val Res.string.existing_members: StringResource by lazy {
      StringResource("string:existing_members", "existing_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4796, 48),
      ))
    }

@delegate:ResourceContentHash(1_756_359_750)
internal val Res.string.existing_members_description: StringResource by lazy {
      StringResource("string:existing_members_description", "existing_members_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4633, 80),
      ))
    }

@delegate:ResourceContentHash(-1_425_637_330)
internal val Res.string.existing_members_icon_cd: StringResource by lazy {
      StringResource("string:existing_members_icon_cd", "existing_members_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1072, 60),
      ))
    }

@delegate:ResourceContentHash(-529_119_980)
internal val Res.string.existing_members_page_description: StringResource by lazy {
      StringResource("string:existing_members_page_description", "existing_members_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4714, 81),
      ))
    }

@delegate:ResourceContentHash(1_936_711_994)
internal val Res.string.field_required: StringResource by lazy {
      StringResource("string:field_required", "field_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4845, 54),
      ))
    }

@delegate:ResourceContentHash(364_452_854)
internal val Res.string.general_error: StringResource by lazy {
      StringResource("string:general_error", "general_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4900, 49),
      ))
    }

@delegate:ResourceContentHash(-63_577_144)
internal val Res.string.go_to_admin: StringResource by lazy {
      StringResource("string:go_to_admin", "go_to_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4950, 35),
      ))
    }

@delegate:ResourceContentHash(45_393_852)
internal val Res.string.going: StringResource by lazy {
      StringResource("string:going", "going", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5022, 21),
      ))
    }

@delegate:ResourceContentHash(1_950_543_509)
internal val Res.string.going_count: StringResource by lazy {
      StringResource("string:going_count", "going_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4986, 35),
      ))
    }

@delegate:ResourceContentHash(-1_792_547_391)
internal val Res.string.hide_password: StringResource by lazy {
      StringResource("string:hide_password", "hide_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5044, 41),
      ))
    }

@delegate:ResourceContentHash(-2_145_057_877)
internal val Res.string.home_icon_cd: StringResource by lazy {
      StringResource("string:home_icon_cd", "home_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1133, 32),
      ))
    }

@delegate:ResourceContentHash(1_878_880_888)
internal val Res.string.home_screen_name: StringResource by lazy {
      StringResource("string:home_screen_name", "home_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5086, 32),
      ))
    }

@delegate:ResourceContentHash(-1_511_517_295)
internal val Res.string.invalid_event_date: StringResource by lazy {
      StringResource("string:invalid_event_date", "invalid_event_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5119, 70),
      ))
    }

@delegate:ResourceContentHash(-155_645_665)
internal val Res.string.invalid_event_time: StringResource by lazy {
      StringResource("string:invalid_event_time", "invalid_event_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5190, 62),
      ))
    }

@delegate:ResourceContentHash(-1_039_317_936)
internal val Res.string.invitation_action_error: StringResource by lazy {
      StringResource("string:invitation_action_error", "invitation_action_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5253, 99),
      ))
    }

@delegate:ResourceContentHash(-1_344_805_882)
internal val Res.string.join_a_club: StringResource by lazy {
      StringResource("string:join_a_club", "join_a_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5353, 35),
      ))
    }

@delegate:ResourceContentHash(1_158_385_508)
internal val Res.string.landing_screen_name: StringResource by lazy {
      StringResource("string:landing_screen_name", "landing_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5389, 47),
      ))
    }

@delegate:ResourceContentHash(709_846_209)
internal val Res.string.loading_more_members: StringResource by lazy {
      StringResource("string:loading_more_members", "loading_more_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5437, 48),
      ))
    }

@delegate:ResourceContentHash(691_855_911)
internal val Res.string.login_button: StringResource by lazy {
      StringResource("string:login_button", "login_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5486, 28),
      ))
    }

@delegate:ResourceContentHash(1_138_387_415)
internal val Res.string.login_screen_name: StringResource by lazy {
      StringResource("string:login_screen_name", "login_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5515, 41),
      ))
    }

@delegate:ResourceContentHash(1_304_679_052)
internal val Res.string.logo_image_cd: StringResource by lazy {
      StringResource("string:logo_image_cd", "logo_image_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1166, 45),
      ))
    }

@delegate:ResourceContentHash(691_852_147)
internal val Res.string.logout: StringResource by lazy {
      StringResource("string:logout", "logout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5557, 22),
      ))
    }

@delegate:ResourceContentHash(953_571_368)
internal val Res.string.logout_icon_cd: StringResource by lazy {
      StringResource("string:logout_icon_cd", "logout_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1212, 38),
      ))
    }

@delegate:ResourceContentHash(1_756_157_090)
internal val Res.string.manage_club: StringResource by lazy {
      StringResource("string:manage_club", "manage_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5737, 35),
      ))
    }

@delegate:ResourceContentHash(671_122_597)
internal val Res.string.manage_club_description: StringResource by lazy {
      StringResource("string:manage_club_description", "manage_club_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5580, 67),
      ))
    }

@delegate:ResourceContentHash(-29_692_507)
internal val Res.string.manage_club_page_description: StringResource by lazy {
      StringResource("string:manage_club_page_description", "manage_club_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5648, 88),
      ))
    }

@delegate:ResourceContentHash(-2_001_039_300)
internal val Res.string.manage_events: StringResource by lazy {
      StringResource("string:manage_events", "manage_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5926, 41),
      ))
    }

@delegate:ResourceContentHash(-1_353_290_906)
internal val Res.string.manage_events_description: StringResource by lazy {
      StringResource("string:manage_events_description", "manage_events_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5773, 69),
      ))
    }

@delegate:ResourceContentHash(1_590_059_417)
internal val Res.string.manage_events_page_description: StringResource by lazy {
      StringResource("string:manage_events_page_description", "manage_events_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5843, 82),
      ))
    }

@delegate:ResourceContentHash(1_637_109_987)
internal val Res.string.manage_members: StringResource by lazy {
      StringResource("string:manage_members", "manage_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6119, 42),
      ))
    }

@delegate:ResourceContentHash(-1_663_510_985)
internal val Res.string.manage_members_description: StringResource by lazy {
      StringResource("string:manage_members_description", "manage_members_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5968, 78),
      ))
    }

@delegate:ResourceContentHash(-149_301_861)
internal val Res.string.manage_members_page_description: StringResource by lazy {
      StringResource("string:manage_members_page_description", "manage_members_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6047, 71),
      ))
    }

@delegate:ResourceContentHash(-1_968_632_274)
internal val Res.string.maybe: StringResource by lazy {
      StringResource("string:maybe", "maybe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6198, 21),
      ))
    }

@delegate:ResourceContentHash(544_610_232)
internal val Res.string.maybe_count: StringResource by lazy {
      StringResource("string:maybe_count", "maybe_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6162, 35),
      ))
    }

@delegate:ResourceContentHash(1_926_713_155)
internal val Res.string.member_actions: StringResource by lazy {
      StringResource("string:member_actions", "member_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6220, 42),
      ))
    }

@delegate:ResourceContentHash(-846_028_144)
internal val Res.string.member_actions_icon_cd: StringResource by lazy {
      StringResource("string:member_actions_icon_cd", "member_actions_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1251, 58),
      ))
    }

@delegate:ResourceContentHash(-844_875_917)
internal val Res.string.member_details: StringResource by lazy {
      StringResource("string:member_details", "member_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6343, 42),
      ))
    }

@delegate:ResourceContentHash(-1_945_186_470)
internal val Res.string.member_details_page_description: StringResource by lazy {
      StringResource("string:member_details_page_description", "member_details_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6263, 79),
      ))
    }

@delegate:ResourceContentHash(-1_668_463_443)
internal val Res.string.member_id: StringResource by lazy {
      StringResource("string:member_id", "member_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6430, 29),
      ))
    }

@delegate:ResourceContentHash(1_429_511_040)
internal val Res.string.member_id_value: StringResource by lazy {
      StringResource("string:member_id_value", "member_id_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6386, 43),
      ))
    }

@delegate:ResourceContentHash(1_804_471_337)
internal val Res.string.member_role: StringResource by lazy {
      StringResource("string:member_role", "member_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6460, 27),
      ))
    }

@delegate:ResourceContentHash(-252_988_690)
internal val Res.string.members_count: StringResource by lazy {
      StringResource("string:members_count", "members_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6488, 37),
      ))
    }

@delegate:ResourceContentHash(1_142_966_777)
internal val Res.string.members_load_more_error: StringResource by lazy {
      StringResource("string:members_load_more_error", "members_load_more_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6526, 83),
      ))
    }

@delegate:ResourceContentHash(644_387_880)
internal val Res.string.members_refresh_error: StringResource by lazy {
      StringResource("string:members_refresh_error", "members_refresh_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6610, 85),
      ))
    }

@delegate:ResourceContentHash(-893_647_673)
internal val Res.string.membership_data_screen_name: StringResource by lazy {
      StringResource("string:membership_data_screen_name", "membership_data_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6696, 67),
      ))
    }

@delegate:ResourceContentHash(1_807_090_061)
internal val Res.string.membership_data_title: StringResource by lazy {
      StringResource("string:membership_data_title", "membership_data_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6764, 49),
      ))
    }

@delegate:ResourceContentHash(-1_921_335_226)
internal val Res.string.membership_settings: StringResource by lazy {
      StringResource("string:membership_settings", "membership_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6814, 55),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.membership_status: StringResource by lazy {
      StringResource("string:membership_status", "membership_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7038, 33),
      ))
    }

@delegate:ResourceContentHash(-1_563_693_251)
internal val Res.string.membership_status_contact_admin: StringResource by lazy {
      StringResource("string:membership_status_contact_admin", "membership_status_contact_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6870, 107),
      ))
    }

@delegate:ResourceContentHash(-7_037_306)
internal val Res.string.membership_status_label: StringResource by lazy {
      StringResource("string:membership_status_label", "membership_status_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6978, 59),
      ))
    }

@delegate:ResourceContentHash(-545_807_339)
internal val Res.string.membership_update_error: StringResource by lazy {
      StringResource("string:membership_update_error", "membership_update_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7072, 99),
      ))
    }

@delegate:ResourceContentHash(1_312_105_241)
internal val Res.string.messages_icon_cd: StringResource by lazy {
      StringResource("string:messages_icon_cd", "messages_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1310, 44),
      ))
    }

@delegate:ResourceContentHash(282_953_173)
internal val Res.string.messages_not_supported_description: StringResource by lazy {
      StringResource("string:messages_not_supported_description", "messages_not_supported_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7172, 102),
      ))
    }

@delegate:ResourceContentHash(-1_202_227_820)
internal val Res.string.messages_not_supported_title: StringResource by lazy {
      StringResource("string:messages_not_supported_title", "messages_not_supported_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7275, 52),
      ))
    }

@delegate:ResourceContentHash(-1_149_763_553)
internal val Res.string.more_icon_cd: StringResource by lazy {
      StringResource("string:more_icon_cd", "more_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1355, 32),
      ))
    }

@delegate:ResourceContentHash(47_763_144)
internal val Res.string.nav_club: StringResource by lazy {
      StringResource("string:nav_club", "nav_club", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7328, 24),
      ))
    }

@delegate:ResourceContentHash(-1_045_627_322)
internal val Res.string.nav_home: StringResource by lazy {
      StringResource("string:nav_home", "nav_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7353, 24),
      ))
    }

@delegate:ResourceContentHash(-670_865_204)
internal val Res.string.nav_messages: StringResource by lazy {
      StringResource("string:nav_messages", "nav_messages", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7378, 32),
      ))
    }

@delegate:ResourceContentHash(2_016_957_626)
internal val Res.string.nav_more: StringResource by lazy {
      StringResource("string:nav_more", "nav_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7411, 24),
      ))
    }

@delegate:ResourceContentHash(755_966_064)
internal val Res.string.nav_profile: StringResource by lazy {
      StringResource("string:nav_profile", "nav_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7436, 31),
      ))
    }

@delegate:ResourceContentHash(1_487_674_460)
internal val Res.string.new_invitations: StringResource by lazy {
      StringResource("string:new_invitations", "new_invitations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7548, 43),
      ))
    }

@delegate:ResourceContentHash(-21_490_139)
internal val Res.string.new_invitations_description: StringResource by lazy {
      StringResource("string:new_invitations_description", "new_invitations_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7468, 79),
      ))
    }

@delegate:ResourceContentHash(-1_161_385_967)
internal val Res.string.new_invitations_icon_cd: StringResource by lazy {
      StringResource("string:new_invitations_icon_cd", "new_invitations_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1388, 59),
      ))
    }

@delegate:ResourceContentHash(943_314_692)
internal val Res.string.new_to_rainbow_clubs: StringResource by lazy {
      StringResource("string:new_to_rainbow_clubs", "new_to_rainbow_clubs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7592, 56),
      ))
    }

@delegate:ResourceContentHash(522_958_261)
internal val Res.string.no_comments_title: StringResource by lazy {
      StringResource("string:no_comments_title", "no_comments_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7649, 49),
      ))
    }

@delegate:ResourceContentHash(1_305_763_554)
internal val Res.string.no_events_to_edit_description: StringResource by lazy {
      StringResource("string:no_events_to_edit_description", "no_events_to_edit_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7699, 105),
      ))
    }

@delegate:ResourceContentHash(-1_856_031_643)
internal val Res.string.no_events_to_edit_title: StringResource by lazy {
      StringResource("string:no_events_to_edit_title", "no_events_to_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7805, 55),
      ))
    }

@delegate:ResourceContentHash(-1_242_375_323)
internal val Res.string.no_existing_members: StringResource by lazy {
      StringResource("string:no_existing_members", "no_existing_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7949, 47),
      ))
    }

@delegate:ResourceContentHash(1_558_478_535)
internal val Res.string.no_existing_members_description: StringResource by lazy {
      StringResource("string:no_existing_members_description", "no_existing_members_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7861, 87),
      ))
    }

@delegate:ResourceContentHash(-881_236_149)
internal val Res.string.no_live_event_for_attendance: StringResource by lazy {
      StringResource("string:no_live_event_for_attendance", "no_live_event_for_attendance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7997, 92),
      ))
    }

@delegate:ResourceContentHash(-1_544_108_971)
internal val Res.string.no_matching_members: StringResource by lazy {
      StringResource("string:no_matching_members", "no_matching_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8158, 55),
      ))
    }

@delegate:ResourceContentHash(-194_475_809)
internal val Res.string.no_matching_members_description: StringResource by lazy {
      StringResource("string:no_matching_members_description", "no_matching_members_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8090, 67),
      ))
    }

@delegate:ResourceContentHash(-202_411_983)
internal val Res.string.no_membership_data_required: StringResource by lazy {
      StringResource("string:no_membership_data_required", "no_membership_data_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8214, 75),
      ))
    }

@delegate:ResourceContentHash(299_440_675)
internal val Res.string.no_pending_invitations: StringResource by lazy {
      StringResource("string:no_pending_invitations", "no_pending_invitations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8389, 62),
      ))
    }

@delegate:ResourceContentHash(1_570_104_963)
internal val Res.string.no_pending_invitations_description: StringResource by lazy {
      StringResource("string:no_pending_invitations_description", "no_pending_invitations_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8290, 98),
      ))
    }

@delegate:ResourceContentHash(1_551_216_521)
internal val Res.string.no_upcoming_events_description: StringResource by lazy {
      StringResource("string:no_upcoming_events_description", "no_upcoming_events_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8452, 102),
      ))
    }

@delegate:ResourceContentHash(1_695_582_428)
internal val Res.string.no_upcoming_events_title: StringResource by lazy {
      StringResource("string:no_upcoming_events_title", "no_upcoming_events_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8555, 56),
      ))
    }

@delegate:ResourceContentHash(-1_152_905_929)
internal val Res.string.not_approved_yet: StringResource by lazy {
      StringResource("string:not_approved_yet", "not_approved_yet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8612, 80),
      ))
    }

@delegate:ResourceContentHash(-1_351_746_419)
internal val Res.string.not_going: StringResource by lazy {
      StringResource("string:not_going", "not_going", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8737, 29),
      ))
    }

@delegate:ResourceContentHash(1_532_926_601)
internal val Res.string.not_going_count: StringResource by lazy {
      StringResource("string:not_going_count", "not_going_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8693, 43),
      ))
    }

@delegate:ResourceContentHash(2_607_126)
internal val Res.string.now: StringResource by lazy {
      StringResource("string:now", "now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8767, 15),
      ))
    }

@delegate:ResourceContentHash(2_552_198)
internal val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8783, 14),
      ))
    }

@delegate:ResourceContentHash(-1_240_678_141)
internal val Res.string.optional_label: StringResource by lazy {
      StringResource("string:optional_label", "optional_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8798, 34),
      ))
    }

@delegate:ResourceContentHash(-472_251_189)
internal val Res.string.password_error: StringResource by lazy {
      StringResource("string:password_error", "password_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8833, 86),
      ))
    }

@delegate:ResourceContentHash(-1_252_028_226)
internal val Res.string.password_field_label: StringResource by lazy {
      StringResource("string:password_field_label", "password_field_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8920, 40),
      ))
    }

@delegate:ResourceContentHash(-1_263_814_224)
internal val Res.string.pending_invitations_count: StringResource by lazy {
      StringResource("string:pending_invitations_count", "pending_invitations_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8961, 49),
      ))
    }

@delegate:ResourceContentHash(-15_597_360)
internal val Res.string.pending_membership_requests: StringResource by lazy {
      StringResource("string:pending_membership_requests", "pending_membership_requests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9011, 71),
      ))
    }

@delegate:ResourceContentHash(2_046_045_051)
internal val Res.string.re_password_field_label: StringResource by lazy {
      StringResource("string:re_password_field_label", "re_password_field_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9083, 55),
      ))
    }

@delegate:ResourceContentHash(-383_134_488)
internal val Res.string.repassword_error: StringResource by lazy {
      StringResource("string:repassword_error", "repassword_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9139, 52),
      ))
    }

@delegate:ResourceContentHash(2_136_935_415)
internal val Res.string.request_to_join_button: StringResource by lazy {
      StringResource("string:request_to_join_button", "request_to_join_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9192, 50),
      ))
    }

@delegate:ResourceContentHash(46_448_881)
internal val Res.string.requested_at: StringResource by lazy {
      StringResource("string:requested_at", "requested_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9290, 36),
      ))
    }

@delegate:ResourceContentHash(-373_162_924)
internal val Res.string.requested_at_value: StringResource by lazy {
      StringResource("string:requested_at_value", "requested_at_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9243, 46),
      ))
    }

@delegate:ResourceContentHash(-781_291_293)
internal val Res.string.required_field: StringResource by lazy {
      StringResource("string:required_field", "required_field", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9327, 34),
      ))
    }

@delegate:ResourceContentHash(-1_468_618_347)
internal val Res.string.save_changes_button: StringResource by lazy {
      StringResource("string:save_changes_button", "save_changes_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9362, 43),
      ))
    }

@delegate:ResourceContentHash(-788_417_337)
internal val Res.string.save_field: StringResource by lazy {
      StringResource("string:save_field", "save_field", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9406, 34),
      ))
    }

@delegate:ResourceContentHash(520_583_030)
internal val Res.string.scan_attendee_qr_code: StringResource by lazy {
      StringResource("string:scan_attendee_qr_code", "scan_attendee_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9441, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("event_time_placeholder", Res.string.event_time_placeholder)
  map.put("event_title_icon_cd", Res.string.event_title_icon_cd)
  map.put("event_title_label", Res.string.event_title_label)
  map.put("event_title_placeholder", Res.string.event_title_placeholder)
  map.put("existing_members", Res.string.existing_members)
  map.put("existing_members_description", Res.string.existing_members_description)
  map.put("existing_members_icon_cd", Res.string.existing_members_icon_cd)
  map.put("existing_members_page_description", Res.string.existing_members_page_description)
  map.put("field_required", Res.string.field_required)
  map.put("general_error", Res.string.general_error)
  map.put("go_to_admin", Res.string.go_to_admin)
  map.put("going", Res.string.going)
  map.put("going_count", Res.string.going_count)
  map.put("hide_password", Res.string.hide_password)
  map.put("home_icon_cd", Res.string.home_icon_cd)
  map.put("home_screen_name", Res.string.home_screen_name)
  map.put("invalid_event_date", Res.string.invalid_event_date)
  map.put("invalid_event_time", Res.string.invalid_event_time)
  map.put("invitation_action_error", Res.string.invitation_action_error)
  map.put("join_a_club", Res.string.join_a_club)
  map.put("landing_screen_name", Res.string.landing_screen_name)
  map.put("loading_more_members", Res.string.loading_more_members)
  map.put("login_button", Res.string.login_button)
  map.put("login_screen_name", Res.string.login_screen_name)
  map.put("logo_image_cd", Res.string.logo_image_cd)
  map.put("logout", Res.string.logout)
  map.put("logout_icon_cd", Res.string.logout_icon_cd)
  map.put("manage_club", Res.string.manage_club)
  map.put("manage_club_description", Res.string.manage_club_description)
  map.put("manage_club_page_description", Res.string.manage_club_page_description)
  map.put("manage_events", Res.string.manage_events)
  map.put("manage_events_description", Res.string.manage_events_description)
  map.put("manage_events_page_description", Res.string.manage_events_page_description)
  map.put("manage_members", Res.string.manage_members)
  map.put("manage_members_description", Res.string.manage_members_description)
  map.put("manage_members_page_description", Res.string.manage_members_page_description)
  map.put("maybe", Res.string.maybe)
  map.put("maybe_count", Res.string.maybe_count)
  map.put("member_actions", Res.string.member_actions)
  map.put("member_actions_icon_cd", Res.string.member_actions_icon_cd)
  map.put("member_details", Res.string.member_details)
  map.put("member_details_page_description", Res.string.member_details_page_description)
  map.put("member_id", Res.string.member_id)
  map.put("member_id_value", Res.string.member_id_value)
  map.put("member_role", Res.string.member_role)
  map.put("members_count", Res.string.members_count)
  map.put("members_load_more_error", Res.string.members_load_more_error)
  map.put("members_refresh_error", Res.string.members_refresh_error)
  map.put("membership_data_screen_name", Res.string.membership_data_screen_name)
  map.put("membership_data_title", Res.string.membership_data_title)
  map.put("membership_settings", Res.string.membership_settings)
  map.put("membership_status", Res.string.membership_status)
  map.put("membership_status_contact_admin", Res.string.membership_status_contact_admin)
  map.put("membership_status_label", Res.string.membership_status_label)
  map.put("membership_update_error", Res.string.membership_update_error)
  map.put("messages_icon_cd", Res.string.messages_icon_cd)
  map.put("messages_not_supported_description", Res.string.messages_not_supported_description)
  map.put("messages_not_supported_title", Res.string.messages_not_supported_title)
  map.put("more_icon_cd", Res.string.more_icon_cd)
  map.put("nav_club", Res.string.nav_club)
  map.put("nav_home", Res.string.nav_home)
  map.put("nav_messages", Res.string.nav_messages)
  map.put("nav_more", Res.string.nav_more)
  map.put("nav_profile", Res.string.nav_profile)
  map.put("new_invitations", Res.string.new_invitations)
  map.put("new_invitations_description", Res.string.new_invitations_description)
  map.put("new_invitations_icon_cd", Res.string.new_invitations_icon_cd)
  map.put("new_to_rainbow_clubs", Res.string.new_to_rainbow_clubs)
  map.put("no_comments_title", Res.string.no_comments_title)
  map.put("no_events_to_edit_description", Res.string.no_events_to_edit_description)
  map.put("no_events_to_edit_title", Res.string.no_events_to_edit_title)
  map.put("no_existing_members", Res.string.no_existing_members)
  map.put("no_existing_members_description", Res.string.no_existing_members_description)
  map.put("no_live_event_for_attendance", Res.string.no_live_event_for_attendance)
  map.put("no_matching_members", Res.string.no_matching_members)
  map.put("no_matching_members_description", Res.string.no_matching_members_description)
  map.put("no_membership_data_required", Res.string.no_membership_data_required)
  map.put("no_pending_invitations", Res.string.no_pending_invitations)
  map.put("no_pending_invitations_description", Res.string.no_pending_invitations_description)
  map.put("no_upcoming_events_description", Res.string.no_upcoming_events_description)
  map.put("no_upcoming_events_title", Res.string.no_upcoming_events_title)
  map.put("not_approved_yet", Res.string.not_approved_yet)
  map.put("not_going", Res.string.not_going)
  map.put("not_going_count", Res.string.not_going_count)
  map.put("now", Res.string.now)
  map.put("ok", Res.string.ok)
  map.put("optional_label", Res.string.optional_label)
  map.put("password_error", Res.string.password_error)
  map.put("password_field_label", Res.string.password_field_label)
  map.put("pending_invitations_count", Res.string.pending_invitations_count)
  map.put("pending_membership_requests", Res.string.pending_membership_requests)
  map.put("re_password_field_label", Res.string.re_password_field_label)
  map.put("repassword_error", Res.string.repassword_error)
  map.put("request_to_join_button", Res.string.request_to_join_button)
  map.put("requested_at", Res.string.requested_at)
  map.put("requested_at_value", Res.string.requested_at_value)
  map.put("required_field", Res.string.required_field)
  map.put("save_changes_button", Res.string.save_changes_button)
  map.put("save_field", Res.string.save_field)
  map.put("scan_attendee_qr_code", Res.string.scan_attendee_qr_code)
}
